import { AppRoute } from '@agentselly/immodossier-shared';
import { exposeViewWidgets } from '~/config/widgets/exposeWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_EXPOSE_$CONTACTID_$PROPERTYID_VIEW,
  exposeViewWidgets,
);
